<div class="text-center mb-3">
  <h1 class="h4">Identity Verification</h1>
  <div class="lead">
    There is not enough information to validate your account at this time. Please contact the Arizona Department of
    Education to continue.
  </div>
</div>
<div class="d-grid">
  <button class="btn btn-primary mx-2" (click)="onContinue()">Continue</button>
</div>
